import config from '@/config';
import { UserState } from '@/types/user';
import axiosInstance from '@/school-management/utils/api';
import { AxiosResponse } from 'axios';

const REGISTRATION_ENDPOINT = `${config.apiVersion}`;

export const registerService = {
  /* LIMIT REGISTRATION WHEN DEAL LIMIT HAS REACHED */
  isRegistrationLimitReached: async (user: UserState | null) => {
    const dealId = user?.metadata?.organizationDetails?.dealId || '';
    const userId = user?.metadata?.id || '';
    const resp: AxiosResponse<any> | null = await axiosInstance.get(
      `${REGISTRATION_ENDPOINT}/is-registration-limit-reached/${userId}/${dealId}`
    );

    return resp;
  },
};
